import script from "./InfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoList.vue?vue&type=script&setup=true&lang=js"

import "./InfoList.vue?vue&type=style&index=0&id=1b31363e&lang=scss"

const __exports__ = script;

export default __exports__